/**
 * Bankame Widget — Integración con Shopify
 *
 * Flujo:
 *   onClientConfirmed  -> crea la orden PENDIENTE en Shopify y la vincula a
 *                         la venta de Bankame
 *   onPaymentConfirmed -> marca la orden como PAGADA y vacía el carrito
 *
 * Precios:
 *   cuotas  -> precio de lista (compare_at_price)
 *   contado -> precio vigente, con descuento
 *
 * Un widget por página: producto o carrito, nunca los dos. El drawer lleva un
 * enlace a /cart, sin widget.
 */

(function () {
  "use strict";

  var config     = window.bankameConfig || {};
  var apiKey     = config.apiKey     || "";
  var widgetUrl  = config.widgetUrl  || "";
  var backendUrl = config.backendUrl || "";
  var storeId    = config.storeId    || "";

  var modo = "product";

  // ═══════════════════════════════════════════════════════════════════
  // Logger
  // ═══════════════════════════════════════════════════════════════════
  var BANKAME_LOG_KEY       = "bankame_frontend_logs_" + storeId;
  var BANKAME_LOG_MAX_LOCAL = 400;
  var BANKAME_CTX_MAX_CHARS = 6000;

  function recortarContexto(context) {
    if (!context) return null;
    try {
      var s = JSON.stringify(context);
      if (s.length <= BANKAME_CTX_MAX_CHARS) return context;
      return { _truncado: true, _largo: s.length, _muestra: s.slice(0, BANKAME_CTX_MAX_CHARS) };
    } catch (e) {
      return { _noSerializable: String(context) };
    }
  }

  function bankameLog(level, message, context) {
    var entry = {
      timestamp: new Date().toISOString(),
      store_id:  storeId,
      source:    "widget-" + modo,
      level:     (level || "INFO").toUpperCase(),
      message:   String(message || ""),
      context:   recortarContexto(context),
      page_url:  window.location.href
    };
    try {
      var tag = "[Bankame:" + entry.level + "]";
      if (entry.level === "ERROR")                                  console.error(tag, entry.message, entry.context || "");
      else if (entry.level === "WARN" || entry.level === "WARNING") console.warn(tag, entry.message, entry.context || "");
      else                                                          console.log(tag, entry.message, entry.context || "");
    } catch (_) {}
    try {
      var stored = JSON.parse(localStorage.getItem(BANKAME_LOG_KEY) || "[]");
      stored.push(entry);
      while (stored.length > BANKAME_LOG_MAX_LOCAL) stored.shift();
      localStorage.setItem(BANKAME_LOG_KEY, JSON.stringify(stored));
    } catch (_) {}
    try {
      if (backendUrl) {
        fetch(backendUrl + "/api/bankame/log-event", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(entry),
          keepalive: true
        }).catch(function () {});
      }
    } catch (_) {}
  }
  window.bankameLog = bankameLog;

  window.bankameDump = function () {
    try {
      return JSON.parse(localStorage.getItem(BANKAME_LOG_KEY) || "[]");
    } catch (e) {
      return [];
    }
  };

  var productWidget = null;
  var cartWidget    = null;

  var saleData = {
    saleId: null,
    shopifyOrderId: null,
    shopifyOrderNumber: null,
    shopifyOrderName: null,
    totalAmount: null,
    initialPaymentAmount: null,
    flowType: null,
    ordenPromesa: null,
    limpiezaPromesa: null
  };

  // ═══════════════════════════════════════════════════════════════════
  // Helpers
  // ═══════════════════════════════════════════════════════════════════

  //   'direct-payment' -> contado
  //   'installments'   -> cuotas
  function detectarFlowType(payload) {
    var p = payload || {};
    return p.flowType || p.flow_type || p.flujo || p.paymentType || p.payment_type || null;
  }

  function resumirPayload(payload) {
    var p = payload || {};
    var claves = [];
    try { claves = Object.keys(p); } catch (e) {}
    return {
      saleId:   p.saleId || p.id || p.sale_id || null,
      flowType: detectarFlowType(p),
      claves:   claves
    };
  }

  function listarMiembros(obj) {
    var out = [];
    if (!obj) return out;
    try {
      for (var k in obj) out.push(k + ":" + typeof obj[k]);
      var proto = Object.getPrototypeOf(obj);
      if (proto && proto !== Object.prototype) {
        Object.getOwnPropertyNames(proto).forEach(function (k) {
          if (out.indexOf(k + ":function") === -1 && k !== "constructor") {
            out.push(k + ":" + typeof obj[k]);
          }
        });
      }
    } catch (e) {}
    return out;
  }

  var CALLBACKS_ESPIA = [
    "onSaleCreated", "onSaleConfirmed", "onSaleCompleted",
    "onCashPayment", "onCashConfirmed", "onDirectPayment", "onDirectPaymentConfirmed",
    "onSuccess", "onComplete", "onCompleted", "onFinish", "onFinished",
    "onOrderCreated", "onOrderConfirmed",
    "onPayment", "onPaymentPending", "onPaymentRejected", "onPaymentFailed",
    "onTransaction", "onTransactionConfirmed",
    "onStatusChange", "onStateChange", "onStep", "onChange", "onUpdate",
    "onQrGenerated", "onVerificationCode",
    "onOpen", "onReady", "onInit", "onClose", "onCancel", "onCancelled"
  ];

  function agregarEspias(opciones) {
    CALLBACKS_ESPIA.forEach(function (nombre) {
      if (typeof opciones[nombre] === "function") return;
      opciones[nombre] = function () {
        var args = [];
        try { args = Array.prototype.slice.call(arguments); } catch (e) {}
        bankameLog("WARN", "SDK disparó un callback no manejado: " + nombre, {
          resumen: resumirPayload(args[0]),
          payload: args[0]
        });
      };
    });
    return opciones;
  }

  function instalarSnifferPostMessage() {
    var origenWidget = "";
    try { origenWidget = new URL(widgetUrl).origin; } catch (e) {}

    window.addEventListener("message", function (ev) {
      try {
        if (origenWidget && ev.origin !== origenWidget) return;
        var data = ev.data;
        if (typeof data === "string") {
          try { data = JSON.parse(data); } catch (e) {}
        }
        bankameLog("INFO", "postMessage del widget", {
          origin:   ev.origin,
          tipo:     (data && (data.type || data.event || data.action || data.name)) || typeof data,
          flowType: detectarFlowType(data) || detectarFlowType(data && data.payload),
          data:     data
        });
      } catch (e) {}
    }, false);

    bankameLog("INFO", "Sniffer de postMessage instalado", { origenEscuchado: origenWidget || "(todos)" });
  }

  function diagnosticoSDK() {
    var tags = [];
    try {
      tags = Array.prototype.slice
        .call(document.querySelectorAll('script[src*="bankame"]'))
        .map(function (s) { return s.src; });
    } catch (e) {}
    return {
      scriptsBankameEnLaPagina: tags,
      tipoDeBankameWidget:      typeof window.BankameWidget,
      widgetUrlConfigurado:     widgetUrl,
      backendUrlConfigurado:    backendUrl,
      hayContenedorProducto:    !!document.getElementById("bankame-product-btn"),
      hayContenedorCarrito:     !!document.getElementById("bankame-cart-btn")
    };
  }
  window.bankameDiagnostico = diagnosticoSDK;

  // Espera por tiempo y no por frames: requestAnimationFrame se congela con la
  // pestaña en segundo plano y el SDK viene de una CDN.
  function initWithRetry(initFn, timeoutMs) {
    var limite = Date.now() + (timeoutMs || 10000);
    (function attempt() {
      if (window.BankameWidget) {
        initFn();
      } else if (Date.now() < limite) {
        setTimeout(attempt, 100);
      } else {
        bankameLog("ERROR", "El SDK nunca definió window.BankameWidget", diagnosticoSDK());
      }
    })();
  }

  // ── Precios ────────────────────────────────────────────────────────
  // Sin flujo conocido se usa el de lista: nunca financiamos por debajo.
  function precioParaFlujo(flowType, precioListaCents, precioVentaCents) {
    var esContado = flowType && String(flowType).toLowerCase().indexOf("direct") !== -1;
    return esContado ? precioVentaCents : precioListaCents;
  }

  function obtenerInputCantidad() {
    return document.querySelector('form[action*="/cart/add"] input[name="quantity"]')
        || document.querySelector('input[name="quantity"][form]')
        || document.querySelector('input[name="quantity"]');
  }

  function obtenerVariantIdSeleccionada() {
    var el = document.querySelector('form[id^="product-form-"]:not([id*="installment"]) [name="id"]')
          || document.querySelector('form[action*="/cart/add"] [name="id"]')
          || document.querySelector('[name="id"]');
    return el ? el.value : null;
  }

  // ── Datos frescos del producto ─────────────────────────────────────
  function obtenerDatosProductoActual(handle, flowType) {
    var variantId = obtenerVariantIdSeleccionada();
    if (!variantId) return Promise.reject(new Error("No hay variante seleccionada"));

    var qtyInput = obtenerInputCantidad();
    var quantity = qtyInput ? (parseInt(qtyInput.value) || 1) : 1;

    return fetch("/products/" + handle + ".js")
      .then(function (res) {
        if (!res.ok) throw new Error("Error al obtener datos del producto");
        return res.json();
      })
      .then(function (fullProductData) {
        var currentVariant = fullProductData.variants.find(function (v) {
          return String(v.id) === String(variantId);
        });
        if (!currentVariant) throw new Error("Variante no encontrada");
        if (!currentVariant.available) throw new Error("Este producto está agotado");

        var compareAt   = currentVariant.compare_at_price || null;
        var precioLista = (compareAt && compareAt > currentVariant.price) ? compareAt : currentVariant.price;
        var precioVenta = currentVariant.price;
        var precioFinal = precioParaFlujo(flowType, precioLista, precioVenta);

        bankameLog("INFO", "Precio elegido para la orden", {
          flowType:    flowType,
          precioLista: precioLista / 100,
          precioVenta: precioVenta / 100,
          usado:       precioFinal / 100
        });

        var producto = {
          variant_id:    String(variantId),
          product_id:    String(fullProductData.id),
          product_title: fullProductData.title,
          variant_title: currentVariant.title || "Default",
          quantity:      quantity,
          price:         (parseFloat(precioFinal) / 100).toFixed(2),
          line_price:    (parseFloat(precioFinal) / 100 * quantity).toFixed(2),
          sku:           currentVariant.sku || "",
          handle:        handle
        };

        bankameLog("INFO", "Datos del producto obtenidos", producto);
        return { items: [producto], subtotalVenta: (precioVenta / 100) * quantity };
      });
  }

  // ── Datos frescos del carrito ──────────────────────────────────────
  // /cart.js no devuelve compare_at_price ni available: se completa con
  // /products/{handle}.js, una vez por producto único del carrito.
  function obtenerDatosCarritoActual(flowType) {
    return fetch("/cart.js")
      .then(function (res) {
        if (!res.ok) throw new Error("Error al obtener el carrito");
        return res.json();
      })
      .then(function (cart) {
        if (!cart.items || cart.items.length === 0) throw new Error("El carrito está vacío");

        var handles = [];
        cart.items.forEach(function (item) {
          if (item.handle && handles.indexOf(item.handle) === -1) handles.push(item.handle);
        });

        return Promise.all(
          handles.map(function (h) {
            return fetch("/products/" + h + ".js")
              .then(function (r) { return r.ok ? r.json() : null; })
              .catch(function () { return null; });
          })
        ).then(function (productos) {
          var comparePorVariante    = {};
          var disponiblePorVariante = {};
          productos.forEach(function (p) {
            if (!p || !p.variants) return;
            p.variants.forEach(function (v) {
              comparePorVariante[String(v.id)]    = v.compare_at_price || null;
              disponiblePorVariante[String(v.id)] = v.available;
            });
          });
          return {
            cart: cart,
            comparePorVariante: comparePorVariante,
            disponiblePorVariante: disponiblePorVariante
          };
        });
      })
      .then(function (data) {
        // Si algo se agotó entre que se pintó la página y el cliente confirmó,
        // se corta acá. Sin dato de la variante no se bloquea.
        var agotados = [];
        data.cart.items.forEach(function (item) {
          var vid = String(item.variant_id || item.id);
          if (data.disponiblePorVariante[vid] === false) {
            agotados.push(item.product_title || item.title);
          }
        });
        if (agotados.length) throw new Error("Sin stock: " + agotados.join(", "));

        var items   = [];
        var details = [];

        data.cart.items.forEach(function (item) {
          var variantId   = String(item.variant_id || item.id);
          var precioVenta = item.final_price;
          var compareAt   = data.comparePorVariante[variantId];
          var precioLista = (compareAt && compareAt > precioVenta) ? compareAt : precioVenta;
          var precioFinal = precioParaFlujo(flowType, precioLista, precioVenta);

          items.push({
            variant_id:    variantId,
            product_id:    String(item.product_id),
            product_title: item.product_title || item.title,
            variant_title: item.variant_title || "Default",
            quantity:      item.quantity,
            price:         (parseFloat(precioFinal) / 100).toFixed(2),
            line_price:    (parseFloat(precioFinal) / 100 * item.quantity).toFixed(2),
            sku:           item.sku || "",
            handle:        item.handle || ""
          });

          details.push({
            product:       item.product_title || item.title,
            unitPrice:     Math.round(precioLista / 100),
            discountPrice: Math.round(precioVenta / 100),
            quantity:      item.quantity
          });
        });

        bankameLog("INFO", "Datos del carrito obtenidos", {
          flowType: flowType, lineas: items.length, total_price: data.cart.total_price / 100
        });

        return { items: items, details: details, subtotalVenta: data.cart.total_price / 100 };
      });
  }

  // ── Vaciar el carrito tras la compra ───────────────────────────────
  // Solo en modo carrito: en modo producto el carrito puede tener cosas
  // ajenas a esta compra. Y solo si la orden llegó a crearse, porque si
  // create-pending-order falló el carrito es el único registro que queda.
  function vaciarCarritoShopify() {
    if (modo !== "cart") return Promise.resolve();

    if (!saleData.shopifyOrderId) {
      bankameLog("WARN", "No se vacía el carrito: la orden no se creó en Shopify", {
        flowType: saleData.flowType, saleId: saleData.saleId
      });
      return Promise.resolve();
    }

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

    return fetch(root + "cart/clear.js", {
      method: "POST", headers: { "Content-Type": "application/json" }, keepalive: true
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok) {
            bankameLog("ERROR", "cart/clear.js falló", { status: r.status, body: j });
            return;
          }
          bankameLog("INFO", "Carrito vaciado tras el pago", {
            item_count: j.item_count, shopify_order_id: saleData.shopifyOrderId
          });
        });
      })
      .catch(function (e) {
        bankameLog("ERROR", "Excepción al vaciar el carrito: " + e.message);
      });
  }

  // La orden de Shopify registra solo el precio de los productos: el envío no
  // se incluye ni en las líneas ni en el total.
  function calcularTotales(productos) {
    var subtotal = productos.reduce(function (sum, p) {
      return sum + parseFloat(p.line_price);
    }, 0);
    return {
      subtotal:     subtotal.toFixed(2),
      total:        subtotal.toFixed(2),
      cuotaInicial: (subtotal / 2).toFixed(2)
    };
  }

  function obtenerDatosCliente(payload, container) {
    var liquidCustomer = {};
    try {
      liquidCustomer = JSON.parse(container.getAttribute("data-customer")) || {};
    } catch (e) {
      liquidCustomer = {};
    }

    var p  = payload || {};
    var wc = p.customer || p.client || p.cliente || {};
    var wcAddress = wc.address || wc.shippingAddress || {};
    var sd = p.shippingData || p.shipping_data || {};

    // El payload de Bankame usa 'firstname' / 'lastname' / 'phone_number'.
    var firstName = p.shippingClientName     || sd.shippingClientName
                 || wc.firstName || wc.first_name || wc.firstname || wc.name
                 || liquidCustomer.first_name || "Cliente";
    var lastName  = p.shippingClientLastName || sd.shippingClientLastName
                 || wc.lastName  || wc.last_name || wc.lastname
                 || liquidCustomer.last_name || "Bankame";
    var email     = p.shippingEmail          || sd.shippingEmail
                 || wc.email || liquidCustomer.email || "";
    var phone     = p.shipingPhoneNumber || p.shippingPhoneNumber
                 || sd.shipingPhoneNumber || sd.shippingPhoneNumber
                 || wc.phone || wc.phone_number || wc.phoneNumber
                 || liquidCustomer.phone || "";
    var street    = p.shippingAddress        || sd.shippingAddress
                 || wcAddress.street || wcAddress.address1 || wc.address
                 || liquidCustomer.address1 || "";
    var city      = p.shippingCity           || sd.shippingCity
                 || wcAddress.city   || wc.city || liquidCustomer.city || "";
    var state     = p.shippingDepartment     || sd.shippingDepartment
                 || wcAddress.state  || wcAddress.province || wc.department
                 || liquidCustomer.province || "";

    var cliente = {
      email: email, first_name: firstName, last_name: lastName, phone: phone,
      address: { street: street, city: city, state: state, country: "BO" }
    };

    bankameLog("INFO", "Datos de cliente resueltos", { cliente: cliente });
    return cliente;
  }

  // ═══════════════════════════════════════════════════════════════════
  // Crear orden pendiente en Shopify y vincularla
  // ═══════════════════════════════════════════════════════════════════
  function crearOrdenPendienteYVincular(payload, container, handle) {
    var flowType   = saleData.flowType;
    var esCarrito  = modo === "cart";

    bankameLog("INFO", "Creando orden pendiente en Shopify", {
      modo: modo, flowType: flowType, saleId: saleData.saleId
    });

    var cliente = obtenerDatosCliente(payload, container);

    var fuenteItems = esCarrito
      ? obtenerDatosCarritoActual(flowType)
      : obtenerDatosProductoActual(handle, flowType);

    return fuenteItems
      .then(function (datos) {
        var productos = datos.items;

        var totales = calcularTotales(productos);
        saleData.totalAmount          = totales.total;
        saleData.initialPaymentAmount = totales.cuotaInicial;

        bankameLog("INFO", "Totales calculados", { flowType: flowType, totales: totales });

        var orderData = {
          customer:               cliente,
          shipping_address:       cliente.address,
          store_id:               storeId,
          shipping_cost:          "0.00",
          items:                  productos,
          total_amount:           totales.total,
          initial_payment_amount: totales.cuotaInicial
        };

        bankameLog("INFO", "create-pending-order → enviando", { body: orderData });

        return fetch(backendUrl + "/api/bankame/create-pending-order", {
          method:  "POST",
          headers: { "Content-Type": "application/json", "X-Store-Id": storeId },
          body:    JSON.stringify(orderData)
        });
      })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (errorData) {
            bankameLog("ERROR", "create-pending-order falló", { status: response.status, body: errorData });
            throw new Error(errorData.error || ("Error " + response.status));
          });
        }
        return response.json();
      })
      .then(function (result) {
        bankameLog("INFO", "create-pending-order OK", { respuestaCompleta: result });

        saleData.shopifyOrderId     = result.shopify_order_id;
        saleData.shopifyOrderNumber = result.shopify_order_number;
        saleData.shopifyOrderName   = result.shopify_order_name;

        if (result.order_status_url || result.order_url) {
          window._bankameOrderUrl = result.order_status_url || result.order_url;
        }

        return vincularOrdenConBankame(result.shopify_order_id, saleData.saleId);
      });
  }

  function vincularOrdenConBankame(shopifyOrderId, bankameSaleId) {
    if (!shopifyOrderId || !bankameSaleId) {
      bankameLog("ERROR", "link-order abortado: falta shopify_order_id o bankame_sale_id", {
        shopifyOrderId: shopifyOrderId, bankameSaleId: bankameSaleId
      });
      return Promise.resolve();
    }

    bankameLog("INFO", "link-order → enviando", {
      shopify_order_id: shopifyOrderId, bankame_sale_id: bankameSaleId
    });

    return fetch(backendUrl + "/api/bankame/link-order", {
      method:  "POST",
      headers: { "Content-Type": "application/json", "X-Store-Id": storeId },
      body:    JSON.stringify({
        shopify_order_id: shopifyOrderId,
        bankame_sale_id:  bankameSaleId,
        store_id:         storeId
      })
    })
      .then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (j) {
          if (!response.ok || j.success === false) {
            bankameLog("ERROR", "link-order respondió error", { status: response.status, body: j });
          } else {
            bankameLog("INFO", "link-order OK", j);
          }
        });
      })
      .catch(function (error) {
        bankameLog("ERROR", "link-order excepción: " + error.message);
      });
  }

  // ═══════════════════════════════════════════════════════════════════
  // Marcar la orden como pagada
  // ═══════════════════════════════════════════════════════════════════
  function notificarPagoConfirmado(bankameTransactionId) {
    var requestBody = {
      bankame_transaction_id: bankameTransactionId,
      store_id:               storeId,
      shopify_order_id:       saleData.shopifyOrderId,
      total_amount:           saleData.totalAmount,
      initial_payment_amount: saleData.initialPaymentAmount,
      payment_date:           new Date().toISOString(),
      payment_method:         "QR",
      payment_reference:      "QR-" + Date.now()
    };

    if (!saleData.shopifyOrderId) {
      bankameLog("ERROR", "payment-confirmed sin shopify_order_id — la orden no existe en Shopify", {
        saleId: bankameTransactionId, saleData: saleData
      });
    }

    bankameLog("INFO", "payment-confirmed → enviando", { body: requestBody });

    return fetch(backendUrl + "/api/bankame/payment-confirmed", {
      method:  "POST",
      headers: { "Content-Type": "application/json", "X-Store-Id": storeId },
      body:    JSON.stringify(requestBody)
    })
      .then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          if (!response.ok || data.success === false) {
            bankameLog("WARN", "payment-confirmed respondió error (webhook debería resolver)", {
              status: response.status, body: data
            });
            return data;
          }
          bankameLog("INFO", "payment-confirmed OK", data);
          return data;
        });
      })
      .catch(function (error) {
        bankameLog("WARN", "payment-confirmed excepción (webhook debería resolver): " + error.message);
      });
  }

  // ═══════════════════════════════════════════════════════════════════
  // Callbacks del SDK
  // ═══════════════════════════════════════════════════════════════════
  function construirCallbacks(container, handle) {
    return {
      onClientConfirmed: function (payload) {
        bankameLog("INFO", "SDK onClientConfirmed", resumirPayload(payload));
        bankameLog("INFO", "Payload completo (onClientConfirmed)", payload);

        var currentSaleId = (payload && (payload.saleId || payload.id)) || null;

        if (currentSaleId && window._bankameOrderCreatedForSaleId === currentSaleId) {
          bankameLog("INFO", "Orden ya creada para este saleId — se ignora el duplicado", { saleId: currentSaleId });
          return;
        }

        window._bankameOrderCreatedForSaleId = currentSaleId;
        window._bankamePaymentConfirmedFor   = null;
        window._bankameOrderUrl              = null;
        if (redirectTimer) { clearTimeout(redirectTimer); redirectTimer = null; }
        pendingRedirectUrl = null;

        saleData.saleId               = currentSaleId;
        saleData.shopifyOrderId       = null;
        saleData.shopifyOrderNumber   = null;
        saleData.shopifyOrderName     = null;
        saleData.totalAmount          = null;
        saleData.initialPaymentAmount = null;
        saleData.flowType             = detectarFlowType(payload);
        saleData.ordenPromesa         = null;
        saleData.limpiezaPromesa      = null;

        saleData.ordenPromesa = crearOrdenPendienteYVincular(payload, container, handle)
          .catch(function (error) {
            bankameLog("ERROR", "Error al crear la orden pendiente: " + error.message);
            window._bankameOrderCreatedForSaleId = null;
            window._bankameOrderUrl = (config.shopUrl || "/") + "?bankame_sale=" + (saleData.saleId || "");
          });
      },

      onPaymentConfirmed: function (payload) {
        bankameLog("INFO", "SDK onPaymentConfirmed", resumirPayload(payload));
        bankameLog("INFO", "Payload completo (onPaymentConfirmed)", payload);

        var transactionId = (payload && (payload.saleId || payload.id)) || saleData.saleId;
        var flowType      = detectarFlowType(payload) || saleData.flowType;
        saleData.flowType = flowType;

        if (transactionId && window._bankamePaymentConfirmedFor === transactionId) {
          bankameLog("INFO", "Pago ya confirmado para este saleId — se ignora el duplicado", { saleId: transactionId });
          return;
        }
        window._bankamePaymentConfirmedFor = transactionId;

        var marcarPagada = function () {
          if (!transactionId) {
            bankameLog("ERROR", "No hay saleId para confirmar el pago", { payload: payload });
            return;
          }
          return notificarPagoConfirmado(transactionId).catch(function (error) {
            bankameLog("ERROR", "Error al actualizar Shopify como pagada: " + error.message);
          });
        };

        if (saleData.ordenPromesa) {
          saleData.ordenPromesa.then(marcarPagada, marcarPagada);
        } else {
          // Flujo al contado: el widget confirma el pago sin pasar por
          // onClientConfirmed, así que la orden se crea recién acá. flowType
          // ya quedó seteado arriba, de modo que se crea con el precio con
          // descuento, que es lo que corresponde al contado.
          bankameLog("WARN", "onPaymentConfirmed sin orden previa — se crea ahora", {
            flowType: flowType, saleId: transactionId
          });

          saleData.saleId                      = saleData.saleId || transactionId;
          window._bankameOrderCreatedForSaleId = transactionId;

          saleData.ordenPromesa = crearOrdenPendienteYVincular(payload, container, handle)
            .catch(function (error) {
              bankameLog("ERROR", "No se pudo crear la orden en el flujo al contado: " + error.message);
              window._bankameOrderCreatedForSaleId = null;
            });

          saleData.ordenPromesa.then(marcarPagada, marcarPagada);
        }

        // Encadenado a la orden: crearOrdenPendienteYVincular lee /cart.js,
        // así que vaciar antes dejaría la orden sin ítems.
        saleData.limpiezaPromesa = saleData.ordenPromesa
          ? saleData.ordenPromesa.then(vaciarCarritoShopify, vaciarCarritoShopify)
          : vaciarCarritoShopify();

        if (pendingRedirectUrl) return;
        var url = (config.shopUrl || "/") + "?bankame_sale=" + (transactionId || "");
        if (window._bankameOrderUrl) url = window._bankameOrderUrl;
        esperarCierreYRedirigir(url);
      },

      onError: function (error) {
        bankameLog("ERROR", "SDK reportó error: " + (error && error.message), {
          error: error, saleData: saleData
        });
      }
    };
  }

  // ═══════════════════════════════════════════════════════════════════
  // Widget de producto
  // ═══════════════════════════════════════════════════════════════════
  function initProductWidget() {
    var container = document.getElementById("bankame-product-btn");
    if (!container) return;

    var handle = container.getAttribute("data-handle") || "";

    var details = [];
    try {
      details = JSON.parse(container.getAttribute("data-product")) || [];
    } catch (e) {
      bankameLog("ERROR", "Error al leer data-product: " + e.message);
      return;
    }

    var preciosPorVariante = {};
    try {
      preciosPorVariante = JSON.parse(container.getAttribute("data-variants")) || {};
    } catch (e) {
      preciosPorVariante = {};
    }

    bankameLog("INFO", "Details enviados al widget (producto)", details);

    var opciones = agregarEspias(construirCallbacks(container, handle));
    opciones.widgetUrl = widgetUrl;
    opciones.apiKey    = apiKey;
    opciones.details   = details;
    opciones.target    = "#bankame-product-btn";

    productWidget = window.BankameWidget.init(opciones);

    bankameLog("INFO", "SDK inicializado (producto)", {
      instancia: listarMiembros(productWidget),
      global:    listarMiembros(window.BankameWidget)
    });

    // Sondeo de cantidad y variante. No toca el DOM del contenedor: solo
    // actualiza los details del SDK y oculta el wrapper si la variante se
    // quedó sin stock.
    var lastQty       = 1;
    var lastVariantId = obtenerVariantIdSeleccionada();

    setInterval(function () {
      if (!productWidget) return;
      var cambio = false;

      var qtyInput = obtenerInputCantidad();
      if (qtyInput) {
        var qty = parseInt(qtyInput.value) || 1;
        if (qty !== lastQty) {
          lastQty = qty;
          details[0].quantity = qty;
          cambio = true;
        }
      }

      var variantId = obtenerVariantIdSeleccionada();
      if (variantId && variantId !== lastVariantId) {
        lastVariantId = variantId;
        var precioVar = preciosPorVariante[variantId];
        if (precioVar) {
          container.style.display = precioVar.available === false ? "none" : "";

          if (precioVar.unitPrice !== details[0].unitPrice
           || precioVar.discountPrice !== details[0].discountPrice) {
            details[0].unitPrice     = precioVar.unitPrice;
            details[0].discountPrice = precioVar.discountPrice;
            cambio = true;
            bankameLog("INFO", "Precio actualizado por variante", {
              variantId: variantId,
              unitPrice: precioVar.unitPrice,
              discountPrice: precioVar.discountPrice
            });
          }
        }
      }

      if (cambio && typeof productWidget.updateDetails === "function") {
        productWidget.updateDetails(JSON.parse(JSON.stringify(details)));
      }
    }, 300);
  }

  // ═══════════════════════════════════════════════════════════════════
  // Widget de carrito
  // ═══════════════════════════════════════════════════════════════════
  function initCartWidget() {
    var container = document.getElementById("bankame-cart-btn");
    if (!container) {
      bankameLog("WARN", "No se encontró #bankame-cart-btn.");
      return;
    }

    var details = [];
    try {
      details = JSON.parse(container.getAttribute("data-product")) || [];
    } catch (e) {
      bankameLog("ERROR", "Error al leer data-product del carrito: " + e.message);
      return;
    }

    if (details.length === 0) {
      bankameLog("INFO", "Carrito sin ítems — no se monta el widget.");
      return;
    }

    bankameLog("INFO", "Details enviados al widget (carrito)", details);

    var opciones = agregarEspias(construirCallbacks(container, null));
    opciones.widgetUrl = widgetUrl;
    opciones.apiKey    = apiKey;
    opciones.details   = details;
    opciones.target    = "#bankame-cart-btn";

    cartWidget = window.BankameWidget.init(opciones);

    bankameLog("INFO", "SDK inicializado (carrito)", {
      instancia: listarMiembros(cartWidget)
    });

    // Re-sincronización al cambiar cantidades. Se escucha el pub/sub del tema
    // y NO se observa el DOM: el contenedor del widget vive dentro de
    // #main-cart-footer, así que un MutationObserver sobre esa raíz se
    // dispararía con los cambios del propio widget y entraría en bucle.
    var refrescoPendiente = null;

    function refrescarDetallesCarrito() {
      if (saleData.limpiezaPromesa) return;

      if (refrescoPendiente) clearTimeout(refrescoPendiente);
      refrescoPendiente = setTimeout(function () {
        refrescoPendiente = null;
        if (!cartWidget) return;

        obtenerDatosCarritoActual(saleData.flowType)
          .then(function (r) {
            container.style.display = r.details.length ? "" : "none";

            details.length = 0;
            r.details.forEach(function (d) { details.push(d); });

            if (typeof cartWidget.updateDetails === "function") {
              cartWidget.updateDetails(JSON.parse(JSON.stringify(details)));
              bankameLog("INFO", "Details del carrito actualizados", { lineas: details.length });
            }
          })
          .catch(function (error) {
            container.style.display = "none";
            bankameLog("WARN", "No se pudo refrescar el carrito: " + error.message);
          });
      }, 250);
    }

    document.addEventListener("bankame:cart-updated", refrescarDetallesCarrito);

    try {
      if (typeof subscribe === "function" && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
        subscribe(window.PUB_SUB_EVENTS.cartUpdate, refrescarDetallesCarrito);
      }
    } catch (e) {
      bankameLog("WARN", "No se pudo suscribir a PUB_SUB_EVENTS.cartUpdate: " + e.message);
    }
  }

  // ── Redirección tras el pago ───────────────────────────────────────
  var pendingRedirectUrl = null;
  var redirectTimer      = null;

  function esperarCierreYRedirigir(orderUrl) {
    if (redirectTimer) clearTimeout(redirectTimer);
    pendingRedirectUrl = orderUrl;
    redirectTimer = setTimeout(function () {
      var irA = function () {
        var url = window._bankameOrderUrl || pendingRedirectUrl;
        pendingRedirectUrl = null;
        redirectTimer      = null;
        bankameLog("INFO", "Redirigiendo tras el pago", { url: url });
        if (url) window.location.href = url;
      };

      var pendientes = [];
      if (saleData.ordenPromesa)    pendientes.push(saleData.ordenPromesa);
      if (saleData.limpiezaPromesa) pendientes.push(saleData.limpiezaPromesa);

      if (pendientes.length) {
        Promise.all(pendientes.map(function (p) { return p.catch(function () {}); })).then(irA, irA);
      } else {
        irA();
      }
    }, 4000);
  }

  window.addEventListener("beforeunload", function () {
    if (productWidget && typeof productWidget.destroy === "function") productWidget.destroy();
    if (cartWidget && typeof cartWidget.destroy === "function") cartWidget.destroy();
  });

  // ═══════════════════════════════════════════════════════════════════
  // Panel de logs (?bankame_logs=1)
  // ═══════════════════════════════════════════════════════════════════
  function renderBankameLogsPanel() {
    var url = new URL(window.location.href);
    var localOn    = url.searchParams.get("bankame_logs") === "1";
    var shortcutOn = localStorage.getItem("bankame_show_logs") === "1";
    if (!localOn && !shortcutOn) return;
    if (document.getElementById("bankameLogsPanel")) return;

    var panel = document.createElement("div");
    panel.id = "bankameLogsPanel";
    panel.style.cssText = "position:fixed;bottom:12px;right:12px;width:520px;max-width:95vw;height:360px;max-height:70vh;background:#0d1117;color:#e6edf3;border:1px solid #30363d;border-radius:8px;box-shadow:0 4px 20px rgba(0,0,0,.4);z-index:2147483647;font-family:ui-monospace,SFMono-Regular,Menlo,monospace;font-size:12px;display:flex;flex-direction:column;overflow:hidden;";

    var header = document.createElement("div");
    header.style.cssText = "padding:8px 12px;background:#161b22;border-bottom:1px solid #30363d;display:flex;justify-content:space-between;align-items:center;font-weight:600;";
    header.innerHTML = "<span>Bankame Logs — " + storeId + " / widget-" + modo + "</span>";

    var btns = document.createElement("div");
    btns.style.cssText = "display:flex;gap:6px;";
    var mkBtn = function (t, on) {
      var b = document.createElement("button");
      b.textContent = t;
      b.style.cssText = "background:#21262d;color:#e6edf3;border:1px solid #30363d;padding:3px 8px;border-radius:4px;cursor:pointer;font-size:11px;";
      b.onclick = on;
      return b;
    };
    btns.appendChild(mkBtn("Refrescar", function () { renderList(); }));
    btns.appendChild(mkBtn("Copiar", function () {
      try {
        var txt = localStorage.getItem(BANKAME_LOG_KEY) || "[]";
        navigator.clipboard.writeText(txt);
        alert("Logs copiados (" + JSON.parse(txt).length + " entradas)");
      } catch (e) { alert("No se pudo copiar: " + e.message); }
    }));
    btns.appendChild(mkBtn("Limpiar", function () { localStorage.removeItem(BANKAME_LOG_KEY); renderList(); }));
    btns.appendChild(mkBtn("✕", function () { panel.remove(); localStorage.removeItem("bankame_show_logs"); }));
    header.appendChild(btns);
    panel.appendChild(header);

    var list = document.createElement("div");
    list.style.cssText = "flex:1;overflow-y:auto;padding:8px 12px;";
    panel.appendChild(list);
    document.body.appendChild(panel);

    function renderList() {
      var logs = JSON.parse(localStorage.getItem(BANKAME_LOG_KEY) || "[]").slice().reverse();
      if (logs.length === 0) {
        list.innerHTML = '<em style="color:#8b949e;">Sin logs</em>';
        return;
      }
      list.innerHTML = "";
      logs.forEach(function (e) {
        var row = document.createElement("div");
        var colors = { ERROR: "#f85149", WARN: "#d29922", WARNING: "#d29922", INFO: "#58a6ff", DEBUG: "#8b949e" };
        var c = colors[e.level] || "#e6edf3";
        row.style.cssText = "padding:5px 0;border-bottom:1px solid #21262d;";
        var ctx = e.context ? '<div style="color:#8b949e;font-size:11px;margin-top:2px;white-space:pre-wrap;">' + JSON.stringify(e.context) + "</div>" : "";
        row.innerHTML = '<div><span style="color:#8b949e;">' + (e.timestamp || "") + '</span> <b style="color:' + c + ';">[' + (e.level || "INFO") + "]</b> " + (e.message || "") + "</div>" + ctx;
        list.appendChild(row);
      });
    }
    renderList();
  }
  window.mostrarBankameLogs = function () {
    localStorage.setItem("bankame_show_logs", "1");
    renderBankameLogsPanel();
  };

  // ═══════════════════════════════════════════════════════════════════
  // Punto de entrada
  // ═══════════════════════════════════════════════════════════════════
  document.addEventListener("DOMContentLoaded", function () {
    if (!apiKey || !widgetUrl) {
      bankameLog("WARN", "API Key o Widget URL no configurados.");
      return;
    }
    if (!backendUrl || !storeId) {
      bankameLog("WARN", "backendUrl o storeId no configurados — las órdenes no se crearán en Shopify.");
    }

    // El modo se decide por el contenedor presente, no solo por el flag.
    if (document.getElementById("bankame-cart-btn") && config.isProduct !== "yes") {
      modo = "cart";
    } else {
      modo = "product";
    }

    bankameLog("INFO", "Bankame widget iniciado", {
      storeId: storeId, modo: modo, isProduct: config.isProduct
    });

    instalarSnifferPostMessage();
    renderBankameLogsPanel();

    if (modo === "cart") {
      initWithRetry(initCartWidget);
    } else {
      initWithRetry(initProductWidget);
    }
  });

})();